import { useState, useEffect } from 'react';

export const useFeatureInext = ( open: boolean, tab: string, data: any) => {
    const [isValidForm, setIsValidForm] = useState<boolean>(true);
    const [list, setList] = useState([]);
    const [form, setForm ] = useState({});
	const config = {
		fields: {
			in: [],
			ex: []
		},
		actions: []
	};

    const handleDelete = (uuid) => {
		let f = form;
        f['roles'].splice(f['roles'].indexOf(uuid), 1);
		if(tab === 'intent'){
			delete f['factor'][uuid]
		}
		if(tab === 'widget'){
			delete f['config'][uuid]
		}
        setForm(JSON.parse(JSON.stringify(f)));
        validateForm(JSON.parse(JSON.stringify(f)));
    };
	
	const onHandleChange = (type, rol, event, arr, click) => {
		let f = form;
		let value = event?.target?.value ? event.target.value as string : event as string;
		if(typeof(value) !== 'string'){
			value = ''
		}

		const evaluate = () => {
			switch (type+'|'+tab) {
				case 'roles|menu':
					f[type].push(value)
					break;
				case 'roles|intent':
					f[type].push(value)
					f['factor'][value] = 'none'
					break;
				case 'roles|widget':
					f[type].push(value)
					f['config'][value] = config
					break;
				case 'factor|intent':
					f[type][rol] = value
					break;
				case 'config|widget':
					f[type][value] = config
					break;
				default:
					f[type] = value
					break;
			}
		}

		switch (click+'|'+rol) {
			case 'createOption|action':
			case 'removeOption|action':
				f['config'][type]['actions'] = arr
				break;
			case 'createOption|ex':
			case 'createOption|in':
			case 'removeOption|ex':
			case 'removeOption|in':
				f['config'][type]['fields'][rol] = arr
				break;
			default:
				evaluate()
				break;
		}

		if(tab === 'widget'){
			Object.keys(f['config']).map((item: any) => {
				let data = f['config'][item]
				if(!data?.hasOwnProperty('actions') && !data?.hasOwnProperty('fields')){
					return f['config'][item] = config
				} else if(data?.hasOwnProperty('actions') && !data?.hasOwnProperty('fields')){
					return f['config'][item]['fields'] = config.fields
				} else if(!data?.hasOwnProperty('actions') && data?.hasOwnProperty('fields')){
					return f['config'][item]['actions'] = config.actions
				}
				return f
			})
		}

		setForm(JSON.parse(JSON.stringify(f)));
        validateForm(JSON.parse(JSON.stringify(f)));
	}

    const validateForm = (f) => {
        if (f['key'] && f['roles'].length > 0 && (tab === 'menu' ? f['name'] && f['type'] : f['description'] )) {
          setIsValidForm(false);
        } else {
          setIsValidForm(true);
        }
    };

    useEffect(() => {
		if(open && !data){
            setList(JSON.parse(JSON.stringify([])))
			let newForm = {
				key: '',
				roles: []
			}

			switch (tab) {
				case 'menu':
					newForm['type'] = '';
					newForm['category'] = '';
					break;
				case 'intent':
					newForm['factor'] = {};
					break;
				case 'widget':
					newForm['config'] = {};
					break;
				default:
					break;
			}
            setForm(newForm)
		}

		if(open && data){
			data['data']['action'] = 'update'
			setList(JSON.parse(JSON.stringify([])))
			setForm(JSON.parse(JSON.stringify(data['data'])))
		}
		if(!open){
			setList(JSON.parse(JSON.stringify([])))
			setForm(JSON.parse(JSON.stringify([])))
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open])

    return { form, list, isValidForm, onHandleChange, onDelete: handleDelete };
};
